import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const Billing = React.lazy(() =>
    import('../Billing')
);
const billingRoutesRegistry = [
    {
        path: PAGE_URL.BILLING_PAGE,
        element: <Billing />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default billingRoutesRegistry;
